import React from 'react';

const SurveyIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.4424 6.88241H20.452V5.99201C20.452 5.70394 20.1378 5.57301 19.8497 5.57301H18.3046C17.938 4.52547 17.0214 4.0017 15.9739 4.0017C14.9378 3.96275 13.9955 4.598 13.6431 5.57301H12.1242C11.8361 5.57301 11.548 5.70394 11.548 5.99201V6.88241H9.55763C8.37816 6.89499 7.41323 7.82543 7.35779 9.00365V24.0096C7.35779 25.1619 8.40533 26 9.55763 26H22.4424C23.5947 26 24.6422 25.1619 24.6422 24.0096V9.00371C24.5868 7.82543 23.6218 6.89499 22.4424 6.88241ZM12.5955 6.62055H14.0359C14.2873 6.58987 14.4893 6.39859 14.5335 6.14916C14.6886 5.47376 15.2811 4.98893 15.9739 4.97069C16.6602 4.99149 17.2438 5.47782 17.388 6.14916C17.435 6.40721 17.6503 6.60095 17.9118 6.62055H19.4046V8.71563H12.5955V6.62055ZM23.5947 24.0097C23.5947 24.5858 23.0185 24.9525 22.4424 24.9525H9.55763C8.98148 24.9525 8.40533 24.5858 8.40533 24.0097V9.00371C8.45876 8.40399 8.95562 7.94098 9.55763 7.93H11.548V9.26562C11.5756 9.55906 11.8298 9.77856 12.1241 9.76322H19.8497C20.1494 9.77961 20.4115 9.56312 20.452 9.26562V7.92995H22.4423C23.0443 7.94098 23.5412 8.40394 23.5946 9.00365V24.0097H23.5947Z'
        fill='#3F4756'
      />
      <path
        d='M13.9835 15.708C13.787 15.5009 13.4609 15.4892 13.2502 15.6818L11.5741 17.2793L10.867 16.546C10.6706 16.3389 10.3444 16.3273 10.1337 16.5198C9.93085 16.7323 9.93085 17.0667 10.1337 17.2793L11.2074 18.3792C11.3004 18.4833 11.4346 18.5408 11.574 18.5363C11.7122 18.5344 11.844 18.4779 11.9407 18.3792L13.9834 16.4413C14.1859 16.2555 14.1994 15.9407 14.0136 15.7382C14.0041 15.7277 13.994 15.7176 13.9835 15.708Z'
        fill='#3F4756'
      />
      <path
        d='M21.4996 16.834H15.4762C15.1869 16.834 14.9525 17.0685 14.9525 17.3578C14.9525 17.647 15.1869 17.8815 15.4762 17.8815H21.4996C21.7888 17.8815 22.0233 17.647 22.0233 17.3578C22.0233 17.0685 21.7888 16.834 21.4996 16.834Z'
        fill='#3F4756'
      />
      <path
        d='M13.9835 11.5178C13.787 11.3107 13.4609 11.299 13.2502 11.4916L11.5741 13.0891L10.867 12.3558C10.6706 12.1487 10.3444 12.137 10.1337 12.3296C9.93085 12.5422 9.93085 12.8766 10.1337 13.0891L11.2074 14.189C11.3004 14.2931 11.4346 14.3506 11.574 14.3462C11.7122 14.3442 11.844 14.2877 11.9407 14.189L13.9834 12.2511C14.1859 12.0653 14.1994 11.7505 14.0136 11.5481C14.0041 11.5375 13.994 11.5274 13.9835 11.5178Z'
        fill='#3F4756'
      />
      <path
        d='M21.4996 12.6439H15.4762C15.1869 12.6439 14.9525 12.8784 14.9525 13.1677C14.9525 13.457 15.1869 13.6914 15.4762 13.6914H21.4996C21.7888 13.6914 22.0233 13.457 22.0233 13.1677C22.0233 12.8784 21.7888 12.6439 21.4996 12.6439Z'
        fill='#3F4756'
      />
      <path
        d='M13.9835 19.898C13.787 19.6909 13.4609 19.6793 13.2502 19.8718L11.5741 21.4693L10.867 20.736C10.6706 20.529 10.3444 20.5173 10.1337 20.7099C9.93085 20.9224 9.93085 21.2568 10.1337 21.4693L11.2074 22.5693C11.3004 22.6733 11.4346 22.7309 11.574 22.7264C11.7122 22.7244 11.844 22.668 11.9407 22.5693L13.9834 20.6313C14.1859 20.4455 14.1994 20.1307 14.0136 19.9283C14.0041 19.9178 13.994 19.9077 13.9835 19.898Z'
        fill='#3F4756'
      />
      <path
        d='M21.4996 21.0242H15.4762C15.1869 21.0242 14.9525 21.2587 14.9525 21.548C14.9525 21.8372 15.1869 22.0717 15.4762 22.0717H21.4996C21.7888 22.0717 22.0233 21.8372 22.0233 21.548C22.0233 21.2587 21.7888 21.0242 21.4996 21.0242Z'
        fill='#3F4756'
      />
    </svg>
  );
};

export default SurveyIcon;
